<template>
  <div class="upgrad_index-warp">
    <van-cell-group>
      <van-cell :title="item.title" :label="item.publishTime" is-link v-for="(item,index) in dataList" :key="index" @click="jumpDetails(item)"/>
    </van-cell-group>
  </div>
</template>
<script>
import utils from '@/utils/common';
export default {
  data(){
    return{
      dataList:[]
    }
  },
  methods: {
    getUserList() {
      this.http({
        url:'order/app/functionInfo/list',
        method:'post',
        parmes:{appName:'user'}
      }).then(rps=>{
        if(rps.code==200){
          this.dataList = rps.data
        }
      })
      this.$loading.hide();
    },
    getBeesList() {
       this.http({
        url:'order/app/functionInfo/list',
        method:'post',
        parmes:{appName:'bee'}
      }).then(rps=>{
        if(rps.code==200){
          this.dataList = rps.data
        }
      })
      this.$loading.hide();
    },
    jumpDetails(item){
      if(item){
        utils.jumpToNewPage({url: window.location.origin +'/h5user/upgrad_details?id='+item.id})
      } 
    }
  },
  created() {
    if (this.$route.query.type == "user") {
      this.getUserList();
    } else {
      this.getBeesList();
    }
  },
}
</script>
<style lang="less" scoped>
  .upgrad_index-warp{
    margin-top: 10px;
  }
</style>